import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "../EventBus";
import Circle from "../../../../../../src/entities/Circle";
import PointManager from "../PointManager";
import AngleManager from "../AngleManager";
import LineManager from "../LineManager";
import { Coord } from "../../../../../../src/types/Interface";
import { runCircleAnimation } from "./CircleAnimationSequence";
import CircleAnimationButton from "../../../../../../src/entities/UI/CircleAnimationButton/CircleAnimationButton";
import { ContextType } from "../../types/Interface";
import { INFO_SLIDER_COORD } from "../../types/Config";


export default class CircleAnimationManager {
  private isSegmentModeActive: boolean = false;

  constructor(
    private PointManager: PointManager,
    private AngleManager: AngleManager,
    private LineManager: LineManager,
    private circle: Circle,
    private cCoord: Coord,
  ) {
    this.AngleManager.draw(PointManager.getRedPoints(), true);
    this.addCircAnimBut();

    eventBus.on(EnumEventBus.segmentMode, v => this.isSegmentModeActive = v);
  }

  getDelayForStartAnim = () => this.isSegmentModeActive ? 150 : 0;

  addCircAnimBut(){
    new CircleAnimationButton(INFO_SLIDER_COORD, () => this.runAnimations(), () => this.getDelayForStartAnim());
  }

  runAnimations() {
    rootEventBus.emit(EnumRootEventBus.startedCircleAnim);
    const context: ContextType = {
      PointManager: this.PointManager,
      AngleManager: this.AngleManager,
      LineManager: this.LineManager,
      circle: this.circle,
      cCoord: this.cCoord
    }

    runCircleAnimation(context, () => {
      rootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
      rootEventBus.emit(EnumRootEventBus.completedCircleAnim);
    });
  }
}
